// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { getDateInformation } from '@tcp/core/src/utils';
import CARTPAGE_CONSTANTS from '@tcp/core/src/components/features/CnC/CartItemTile/CartItemTile.constants';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { labelsObject } from '@tcp/core/src/components/common/organisms/PickupStoreModal/molecules/PickupStoreSelectionForm/views/PickupStoreSelectionForm.labels.js';
import useHasMounted from '@tcp/core/src/hooks/useHasMounted';
import BodyCopy from '../../../atoms/BodyCopy';
import styles from '../styles/DeliveryMethods.style';
import withStyles from '../../../hoc/withStyles';
import DeliveryButton from '../../DeliveryMethodButton/DeliveryButton.view';
import { getNextOpenDay } from '../../../../../utils/getNextDayDate.util';

const hideBopisCheck = (
  isOnlineExclusive,
  isBopisEnabled,
  brand,
  isStoreSpecialsPricePresent,
  shouldAllowOnlineProductPickup
) => {
  const isOnlineExclusiveNew = isOnlineExclusive && !isStoreSpecialsPricePresent;
  const isBopisEnabledNew = !isBopisEnabled && !isStoreSpecialsPricePresent;

  if (shouldAllowOnlineProductPickup) {
    return isBopisEnabledNew;
  }
  return isOnlineExclusiveNew || isBopisEnabledNew;
};

const verifyDisabled = (
  checkForOOSForVariant,
  isAllSizeDisabled,
  unavailable,
  other,
  isPickUpSelected,
  deliveryMethod = ''
) => {
  return checkForOOSForVariant ||
    (isAllSizeDisabled && isPickUpSelected?.toLowerCase() === deliveryMethod?.toLowerCase())
    ? unavailable
    : other;
};

const checkLoadingState = (changedOrderType, orderType, loading) => {
  return loading && changedOrderType === orderType;
};

const getMinMaxDates = (userDefaultStore) => {
  const minDate =
    userDefaultStore?.storeBossInfo?.startDate || userDefaultStore?.features?.bossMinDate;
  const maxDate =
    userDefaultStore?.storeBossInfo?.endDate || userDefaultStore?.features?.bossMaxDate;
  const pasedMin = minDate?.replace(/-/g, '/');
  const pasedMax = maxDate?.replace(/-/g, '/');

  const maxBossDate = pasedMax ? getDateInformation(pasedMax) : '';
  const minBossDate = pasedMin ? getDateInformation(pasedMin) : '';
  return {
    maxBossDate,
    minBossDate,
  };
};

const getDateRangeFromShipment = (shipment) => {
  if (!shipment?.bossMaxDate || !shipment?.bossMinDate) {
    return null;
  }
  const maxBossDate = getDateInformation(shipment?.bossMaxDate);
  const minBossDate = getDateInformation(shipment?.bossMinDate);

  return `${minBossDate?.month} ${minBossDate?.date} - ${maxBossDate?.month} ${maxBossDate?.date}`;
};

const minMaxDateRange = (minBossDate, maxBossDate) => {
  if (minBossDate?.month === maxBossDate?.month && minBossDate?.date === maxBossDate?.date) {
    return `${minBossDate?.month} ${minBossDate?.date}`;
  }
  return `${minBossDate?.month} ${minBossDate?.date} - ${maxBossDate?.month} ${maxBossDate?.date}`;
};

const allSizeCheck = (isPickUpSelected, methodSelected, allSizeDisabledCheck) => {
  return isPickUpSelected === methodSelected && allSizeDisabledCheck;
};

const shouldRender = (hideBoss, hideBopis) => {
  return !hideBoss || !hideBopis;
};

const getBossBopisFlags = ({
  isOnlineExclusive,
  isBopisEnabled,
  brand,
  isCanada,
  isBossEnabled,
  userDefaultStore,
  isStoreSpecialsPricePresent,
  shouldAllowOnlineProductPickup,
}) => {
  const hideBopis = hideBopisCheck(
    isOnlineExclusive,
    isBopisEnabled,
    brand,
    isStoreSpecialsPricePresent,
    shouldAllowOnlineProductPickup
  );
  const hideBoss = isCanada || !isBossEnabled;
  const isDefaultStoreBossEligible = userDefaultStore?.storeBossInfo?.isBossEligible;
  return { hideBopis, hideBoss, isDefaultStoreBossEligible };
};

const getMinMaxBossRangeString = ({
  isDefaultStoreBossEligible,
  maxBossDate,
  minBossDate,
  shipment,
}) => {
  return isDefaultStoreBossEligible && (maxBossDate || minBossDate)
    ? getDateRangeFromShipment(shipment) || minMaxDateRange(minBossDate, maxBossDate)
    : '';
};

const setUpdatedBopisSubHeading = ({
  isDisplayPickupTimeEnabled,
  storeHoursThreshold,
  getItToday,
  storeInformation,
}) => {
  if (isDisplayPickupTimeEnabled && storeInformation) {
    const dayDetails = getNextOpenDay({
      hoursBeforeClose: storeHoursThreshold,
      storeInformation,
    });
    const { dayName, openDate } = dayDetails || {};
    const getItLbl = getLabelFromCopyOrFromTranslation(
      'Browse.ProductPickup.lbl_Product_pickup_Get_it',
      labelsObject
    );

    if (openDate) {
      return `${dayName}${openDate ? `, ${openDate}` : ''}`;
    }

    return dayName ? `${renderLabel(getItLbl, 'lbl_Product_pickup_Get_it')} ${dayName}!` : '';
  }
  return getItToday;
};

function DeliveryMethods(props) {
  const {
    isPickUpSelected,
    pickupSelectionUpdate,
    className,
    quickViewLabels,
    isOnlineExclusive,
    isBossEnabled,
    checkForOOSForVariant,
    isAllSizeDisabled,
    isBopisEnabled,
    userDefaultStore,
    isStoreBopisEligible,
    itemBrand,
    fulfillmentGroup,
    shippingMethodSelected,
    loading,
    changedOrderType,
    orderEddDates,
    isCanada,
    isCartTile,
    newBag,
    brand,
    shipment,
    eddData,
    isVariantsHasPreOrder,
    miscInfo,
    isShowShipToHomeEddEnabled,
    isPreOrderItemsIncluded,
    isBopisMultipleStoreEnabled,
    isBossMultipleStoreEnabled,
    shouldShowSizeError,
    displayErrorMessage,
    isPDP,
    isQuickView,
    shipments,
    freeShippingThershold,
    shippingTotal,
    isDynamicFreeShippingEnabled,
    orderType,
    productTotal,
    isDisplayPickupTimeEnabled,
    storeHoursThreshold,
    isFullDateDisplayEnabled,
    isBopisPromoDiscountBannerEnabled,
    storeInformation,
    isStoreSpecialsPricePresent,
    setMethod,
    shouldAllowOnlineProductPickup,
    freeShippingThreshold,
    freeShipsMsg,
    isFreeShippingOnFulfillmentTileEnabled,
  } = props;
  const { HOME, BOPIS, BOSS } = CARTPAGE_CONSTANTS;
  const { hideBopis, hideBoss, isDefaultStoreBossEligible } = getBossBopisFlags({
    isOnlineExclusive,
    isBopisEnabled,
    brand,
    isCanada,
    isBossEnabled,
    userDefaultStore,
    isStoreSpecialsPricePresent,
    shouldAllowOnlineProductPickup,
  });

  const { maxBossDate, minBossDate } = getMinMaxDates(userDefaultStore);
  const minMaxBossRangeString = getMinMaxBossRangeString({
    isDefaultStoreBossEligible,
    maxBossDate,
    minBossDate,
    shipment,
  });

  const buttonSize = hideBopis || hideBoss ? 'button-2' : 'button-3';
  if (isOnlineExclusive && !isBossEnabled && !shouldAllowOnlineProductPickup) {
    return null;
  }
  const hasMounted = useHasMounted();
  const pickUpSelected = isPickUpSelected === BOPIS.toLowerCase() ? false : checkForOOSForVariant;
  const bopisSubHeading = setUpdatedBopisSubHeading({
    getItToday: quickViewLabels?.getItToday,
    isDisplayPickupTimeEnabled,
    storeHoursThreshold,
    isFullDateDisplayEnabled,
    storeInformation,
  });

  return (
    shouldRender(hideBoss, hideBopis) && (
      <div className={`${className}`}>
        {!fulfillmentGroup && (
          <BodyCopy
            className="fulfillment-section-heading quick-view-drawer-redesign"
            fontSize="fs14"
            fontFamily="secondary"
            fontWeight="extrabold"
          >
            {quickViewLabels?.deliveryMethod}
          </BodyCopy>
        )}
        <div className={` delivery-section`}>
          <DeliveryButton
            heading={isCartTile ? quickViewLabels?.shipping : quickViewLabels?.shipToHome}
            subheading={verifyDisabled(
              checkForOOSForVariant,
              isAllSizeDisabled,
              quickViewLabels?.unavailable,
              quickViewLabels?.freeShipping,
              isPickUpSelected,
              HOME
            )}
            isPickUpSelected={isPickUpSelected === HOME}
            loading={checkLoadingState(changedOrderType, HOME, loading)}
            pickupSelectionUpdate={pickupSelectionUpdate}
            value={HOME}
            buttonSize={buttonSize}
            checkForOOSForVariant={checkForOOSForVariant}
            isAllSizeDisabled={allSizeCheck(isPickUpSelected, HOME, isAllSizeDisabled)}
            shippingMethodSelected={fulfillmentGroup && shippingMethodSelected}
            fulfillmentGroup={fulfillmentGroup}
            orderEddDates={orderEddDates}
            showEdd={isCartTile && !isCanada}
            isCartTile={isCartTile}
            newBag={newBag}
            eddData={eddData}
            isVariantsHasPreOrder={isVariantsHasPreOrder}
            isShowShipToHomeEddEnabled={isShowShipToHomeEddEnabled}
            miscInfo={miscInfo}
            isPreOrderItemsIncluded={isPreOrderItemsIncluded}
            isPDP={isPDP}
            isQuickView={isQuickView}
            shipments={shipments}
            freeShippingThershold={freeShippingThershold}
            shippingTotal={shippingTotal}
            isDynamicFreeShippingEnabled={isDynamicFreeShippingEnabled}
            orderType={orderType}
            productTotal={productTotal}
            setMethod={setMethod}
            freeShippingThreshold={freeShippingThreshold}
            freeShipsMsg={freeShipsMsg}
            isFreeShippingOnFulfillmentTileEnabled={isFreeShippingOnFulfillmentTileEnabled}
          />
          {!hideBopis && (
            <DeliveryButton
              heading={quickViewLabels?.pickUp}
              subheading={pickUpSelected ? quickViewLabels?.unavailable : bopisSubHeading}
              isPickUpSelected={isPickUpSelected === BOPIS.toLowerCase()}
              loading={checkLoadingState(changedOrderType, BOPIS.toLowerCase(), loading)}
              pickupSelectionUpdate={pickupSelectionUpdate}
              value={BOPIS.toLowerCase()}
              buttonSize={buttonSize}
              checkForOOSForVariant={pickUpSelected}
              isStoreBopisEligible={isStoreBopisEligible}
              fulfillmentGroup={fulfillmentGroup}
              isCartTile={isCartTile}
              isPreOrderItemsIncluded={isPreOrderItemsIncluded}
              isBopisMultipleStoreEnabled={isBopisMultipleStoreEnabled}
              shouldShowSizeError={shouldShowSizeError}
              displayErrorMessage={displayErrorMessage}
              isDisplayPickupTimeEnabled={isDisplayPickupTimeEnabled}
              storeHoursThreshold={storeHoursThreshold}
              isBopisPromoDiscount={isBopisPromoDiscountBannerEnabled}
              isBopisEnabled={isBopisEnabled}
              storeInformation={storeInformation}
              setMethod={setMethod}
              isStoreSpecialsPricePresent={isStoreSpecialsPricePresent}
            />
          )}
          {!hideBoss && (
            <DeliveryButton
              heading={quickViewLabels?.norushpickUp}
              subheading={
                hasMounted
                  ? verifyDisabled(
                      checkForOOSForVariant,
                      isAllSizeDisabled,
                      quickViewLabels?.unavailable,
                      minMaxBossRangeString,
                      isPickUpSelected,
                      BOSS
                    )
                  : ''
              }
              badge={quickViewLabels?.extraPercentOff}
              isPickUpSelected={isPickUpSelected === BOSS.toLowerCase()}
              pickupSelectionUpdate={pickupSelectionUpdate}
              value={BOSS.toLowerCase()}
              buttonSize={buttonSize}
              checkForOOSForVariant={checkForOOSForVariant}
              isAllSizeDisabled={allSizeCheck(isPickUpSelected, BOSS, isAllSizeDisabled)}
              itemBrand={itemBrand}
              fulfillmentGroup={fulfillmentGroup}
              loading={checkLoadingState(changedOrderType, BOSS.toLowerCase(), loading)}
              isCartTile={isCartTile}
              isPreOrderItemsIncluded={isPreOrderItemsIncluded}
              isBossMultipleStoreEnabled={isBossMultipleStoreEnabled}
              shouldShowSizeError={shouldShowSizeError}
              displayErrorMessage={displayErrorMessage}
            />
          )}
        </div>
      </div>
    )
  );
}

DeliveryMethods.propTypes = {
  className: PropTypes.string,
  itemBrand: PropTypes.string,
  quickViewLabels: PropTypes.shape({
    addToBag: PropTypes.string,
    viewProductDetails: PropTypes.string,
  }).isRequired,
  pickupSelectionUpdate: PropTypes.func,
  isPickUpSelected: PropTypes.string,
  isOnlineExclusive: PropTypes.bool,
  isBossEnabled: PropTypes.bool,
  miscInfo: PropTypes.shape({}),
  isAllSizeDisabled: PropTypes.bool,
  checkForOOSForVariant: PropTypes.bool,
  userDefaultStore: PropTypes.shape({}),
  changedOrderType: PropTypes.string,
  loading: PropTypes.bool,
  isCanada: PropTypes.bool,
  buttonSize: PropTypes.bool.isRequired,
  isCartTile: PropTypes.bool,
  newBag: PropTypes.bool,
  shipment: PropTypes.shape({}),
  isBopisPromoDiscountBannerEnabled: PropTypes.bool,
};

DeliveryMethods.defaultProps = {
  className: '',
  itemBrand: '',
  isPickUpSelected: '',
  pickupSelectionUpdate: () => {},
  isOnlineExclusive: false,
  isBossEnabled: false,
  miscInfo: {},
  isAllSizeDisabled: false,
  checkForOOSForVariant: false,
  userDefaultStore: {},
  changedOrderType: '',
  loading: false,
  isCanada: false,
  isCartTile: false,
  newBag: false,
  shipment: {},
  isBopisPromoDiscountBannerEnabled: false,
};

export default withStyles(DeliveryMethods, styles);
export { DeliveryMethods as DeliveryMethodsVanilla };
